import {observable, action, makeObservable} from 'mobx';
import {snackbarTypesEnum} from "../enums";


export class ModalStore {

    constructor() {
        makeObservable(this, {
            silent: observable,
            isDeleteNodeDialogOpen: observable,
            isCreateRenameModalOpen: observable,
            isCreateEditLinkModalOpen: observable,
            isJoinProjectModalOpen: observable,
            isDeleteProjectDialogOpen: observable,
            isDeleteTaskDialogOpen: observable,
            isDeleteUserDialogOpen: observable,
            isChangeEmailDialogOpen: observable,
            isCropperModalOpen: observable,
            isUploadModalOpen: observable,
            isUploadProcedureModalOpen: observable,
            isZoomWarningModalOpen: observable,
            isProcedurePreviewModalOpen: observable,
            isShareProcedureModalOpen: observable,
            isGenerateQRModalOpen: observable,
            isMediaLibraryModalOpen: observable,
            isDeleteRoleDialogOpen: observable,
            isDeleteModeDialogOpen: observable,
            isRichTextEditorModalOpen: observable,
            isSelectFusionDialogOpen: observable,
            isPublishVersionModal: observable,
            isReleaseNotesModalOpen: observable,
            isCreateMediaProcedureDialogOpen: observable,
            isEditMediaProcedureDialogOpen: observable,
            isCreateMediaFolderDialogOpen: observable,
            isDeleteMediaItemsModalOpen: observable,
            isReplaceMediaModalOpen: observable,
            isUnPublishProcedureModalOpen: observable,
            isProcedurePublishedModalOpen: observable,
            isSessionPlayerModalOpen: observable,
            isTooManyConnectionsModalOpen: observable,
            isChatAiModalOpen: observable,
            isKickedOutModalOpen: observable,
            isViewSessionModalOpen: observable,
            dataRefreshModalOpen: observable,
            isDomainExpiredModalOpen: observable,
            isDomainBlockedModalOpen: observable,
            isSwitchDomainModalOpen: observable,
            isTooManyUsersModalOpen: observable,
            isDeleteNotificationsModalOpen: observable,
            isCreateChecklistDialogOpen: observable,
            isFrontlineArDialogOpen: observable,
            isDayadaPasswordDialogOpen: observable,
            isEmbedProcedureModalOpen: observable,
            isProcedureStatsModalOpen: observable,
            isProcedureSettingsModalOpen: observable,
            isFolderSettingsModalOpen: observable,
            isProjectSettingsModalOpen: observable,
            isEdit3dAvatarModalOpen: observable,
            isUseAsRegularAvatarModalOpen: observable,
            isGenericSelectSearchModalOpen: observable,
            isGenericSelectSearchModalLoading: observable,
            isCreateEditWorkspaceModalOpen: observable,
            isGenerateSubWorkspaceReportsModalOpen: observable,
            alertMessage: observable,
            keepOpen: observable,
            modalData: observable,
            projectToBeChanged: observable,
            folderToBeChanged: observable,
            procedureToBeChanged: observable,
            isActionSnackBarOpen: observable,
            actionSnackBarText: observable,
            actionSnackBarCallback: observable,
            actionSnackBarButtonText: observable,
            isGenericModalOpen: observable,
            resetModalData: action,
            showErrorMessage: action,
            showSuccessMessage: action,
            isDayadaFilePreviewDialogOpen: observable,
            isRemindToPublishModalOpen: observable,
            isPayPerClickSharingOpen: observable,
            isCancelPayPerClickModalOpen: observable,
            isPayPerClickAnalyticsOpen: observable,
            // isConfirmAddSdkToUserOpen: observable,
            isEditorLanguageModalOpen: observable,
            isConfirmChangeDefaultLanguageOpen: observable,
            isHideHelpButtonModalOpen: observable,
            isSetInteractionsEditorModalOpen: observable,
            isOpenSizePopup: observable,
            isDeleteInteractionDialogOpen: observable,
            isDuplicateItemsModalOpen: observable,
            isDeleteItemsModalOpen: observable,
            isGeneralConfirmActionDialogOpen: observable,
            isAutoGenerateReportsModalOpen: observable,
            isSetSitePrepNameModalOpen: observable,
            isSelectSitePrepFusionFilesModalOpen: observable,
            isEditSitePrepChecklistModalOpen: observable,
            isSelectSitePrepTemplateModalOpen: observable,
            isAddSitePrepUsersModalOpen: observable,
            isShowCodeEditor: observable,
            isSelectDigitalTwinUploadModalOpen: observable,
            isSetInteractionFolderNameModalOpen: observable,
            isSetInteractionNameModalOpen: observable,
            isFindProcedureAttachmentOpen: observable,
            isChooseRolePopupOpen: observable,
            chooseRolePopupPosition: observable,
            chooseInitRoleState: observable,
            handleSaveRolePopup: observable,
            chooseRolePopupConfig: observable,
            isFilePreviewModalOpen: observable,
            isFilePreviewModalLoading: observable,
            isSurveyPopupOpen: observable,
            isSurveyOpen: observable,
            runAsync: action,
            showInfoMessage: action,
            showActionMessage: action,
            isLoadingWorkspaces: observable,
            isInteractionUsagesModalOpen: observable,
            isRecordingWarningModalOpen: observable,
            isAccessModalOpen: observable,
            isInviteMembersModalOpen: observable,
        });
    }

    silent = false;
    isHideHelpButtonModalOpen = false;
    isCreateRenameModalOpen = false;
    isCreateEditLinkModalOpen = false;
    isJoinProjectModalOpen = false;
    isZoomWarningModalOpen = false;
    isRecordingWarningModalOpen = false;
    isAccessModalOpen = false;
    isInviteMembersModalOpen = false;
    isDeleteProjectDialogOpen = false;
    isDeleteTaskDialogOpen = false;
    isDeleteUserDialogOpen = false;
    isChangeEmailDialogOpen = false;
    isCropperModalOpen = false;
    isUploadModalOpen = false;
    isUploadProcedureModalOpen = false;
    isProcedurePreviewModalOpen = false;
    isShareProcedureModalOpen = false;
    isGenerateQRModalOpen = false;
    isMediaLibraryModalOpen = false;
    isDeleteRoleDialogOpen = false;
    isDeleteModeDialogOpen = false;
    isRichTextEditorModalOpen = false;
    isSelectFusionDialogOpen = false;
    isPublishVersionModal = false;
    isReleaseNotesModalOpen = false;
    isCreateMediaProcedureDialogOpen = false;
    isEditMediaProcedureDialogOpen = false;
    isCreateMediaFolderDialogOpen = false;
    isDeleteMediaItemsModalOpen = false;
    isReplaceMediaModalOpen = false;
    isUnPublishProcedureModalOpen = false;
    isProcedurePublishedModalOpen = false;
    isSessionPlayerModalOpen = false;
    isTooManyConnectionsModalOpen = false;
    isChatAiModalOpen = false;
    isKickedOutModalOpen = false;
    isViewSessionModalOpen = false;
    dataRefreshModalOpen = false;
    isDomainExpiredModalOpen = false;
    isDomainBlockedModalOpen = false;
    isSwitchDomainModalOpen = false;
    isTooManyUsersModalOpen = false;
    isDeleteNotificationsModalOpen = false;
    isCreateChecklistDialogOpen = false;
    isFrontlineArDialogOpen = false;
    isDayadaPasswordDialogOpen = false;
    isEmbedProcedureModalOpen = false;
    isProcedureStatsModalOpen = false;
    isProcedureSettingsModalOpen = false;
    isFolderSettingsModalOpen = false;
    isProjectSettingsModalOpen = false;
    isEdit3dAvatarModalOpen = false;
    isUseAsRegularAvatarModalOpen = false;
    isDayadaFilePreviewDialogOpen = false;
    isRemindToPublishModalOpen = false;
    isPayPerClickSharingOpen = false;
    isCancelPayPerClickModalOpen = false;
    isPayPerClickAnalyticsOpen = false;
    // isConfirmAddSdkToUserOpen = false;
    isDeleteNodeDialogOpen = false;
    isEditorLanguageModalOpen = false;
    isConfirmChangeDefaultLanguageOpen = false;
    isSetInteractionsEditorModalOpen = false;
    isOpenSizePopup = false;
    isDeleteInteractionDialogOpen = false;
    isDuplicateItemsModalOpen = false;
    isDeleteItemsModalOpen = false;
    isGeneralConfirmActionDialogOpen = false;
    isAutoGenerateReportsModalOpen = false;
    isSetSitePrepNameModalOpen = false;
    isSelectSitePrepFusionFilesModalOpen = false;
    isEditSitePrepChecklistModalOpen = false;
    isSelectSitePrepTemplateModalOpen = false;
    isAddSitePrepUsersModalOpen = false;
    isShowCodeEditor = false;
    isSelectDigitalTwinUploadModalOpen = false;
    isGenericSelectSearchModalOpen = false;
    isGenericSelectSearchModalLoading = false;
    isCreateEditWorkspaceModalOpen = false;
    isGenerateSubWorkspaceReportsModalOpen = false;
    alertType = snackbarTypesEnum.INFO;
    alertMessage = '';
    isSetInteractionFolderNameModalOpen = false;
    isSetInteractionNameModalOpen = false;
    keepOpen = false;
    modalData = {};
    isFindProcedureAttachmentOpen = false;

    projectToBeChanged = null;
    folderToBeChanged = null;
    procedureToBeChanged = null;
    isActionSnackBarOpen = false;
    actionSnackBarButtonText = '';
    isGenericModalOpen = false
    isLoadingWorkspaces = false;
    isChooseRolePopupOpen = false
    chooseRolePopupPosition = {x: 100, y: 500}
    chooseInitRoleState= new Set()
    handleSaveRolePopup = () =>{}
    chooseRolePopupConfig = {singleSelect: false, showAdministration: false}
    isFilePreviewModalOpen = false;
    isFilePreviewModalLoading = false;
    isInteractionUsagesModalOpen = false;
    isSurveyPopupOpen = false;
    isSurveyOpen = false;
    actionSnackBarCallback = () => {
    };
    actionSnackBarText = '';

    resetModalData = () => {
        this.modalData = {}
    };

    showActionMessage = (message, callback, buttonText) => {
        this.isActionSnackBarOpen = true;
        this.actionSnackBarText = message
        this.actionSnackBarCallback = callback;
        this.actionSnackBarButtonText = buttonText;
    };

    showInfoMessage = (message) => {
        this.alertType = snackbarTypesEnum.INFO;
        this.alertMessage = message;
    };

    showErrorMessage = (message, keepOpen = false) => {
        if (this.silent) {
            return;
        }
        this.keepOpen = keepOpen
        this.alertType = snackbarTypesEnum.ERROR;
        this.alertMessage = message;
    };

    showSuccessMessage = (message, keepOpen = false) => {
        this.keepOpen = keepOpen
        this.alertType = snackbarTypesEnum.SUCCESS;
        this.alertMessage = message;
    };

    runAsync = async (promise, errorMessage, successMessage, loadingMessage) => {
        try {
            this.showInfoMessage(loadingMessage);
            const retVal = await promise;
            if (successMessage) {
                this.showSuccessMessage(successMessage);
            } else {
                this.alertMessage = '';
            }
            return retVal;
        } catch (e) {
            console.error(e);
            this.showErrorMessage(errorMessage);
            return null;
        }
    }
}